"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const maxTextWidth = 160;
const StyledTextContainer = styled_components_1.default.div `
  width: 100%;
  height: auto;
  max-width: ${ui_common_components_1.utils.rem(maxTextWidth)};
  position: relative;
`;
const StyledIcon = styled_components_1.default.span `
  position: absolute;
  top: ${ui_common_components_1.utils.rem(10)};
  right: ${ui_common_components_1.utils.rem(7)};
`;
function Text({ initialValue, title, id, onUpdate }) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const handleResult = (0, react_1.useCallback)((inputValue) => {
        setValue(inputValue);
        onUpdate(inputValue);
    }, [onUpdate]);
    return ((0, jsx_runtime_1.jsxs)(StyledTextContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: id, name: title, value: value, onChange: (inputValue) => handleResult(inputValue), placeholder: title }), (0, jsx_runtime_1.jsx)(StyledIcon, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "chevron---20" }) })] }));
}
exports.Text = Text;
//# sourceMappingURL=Text.js.map